import ShareModal from '@ui/Share/Modal/component'

export default function (): void {
  const modalEl = document.getElementById('dca-product-share-modal')

  if (!modalEl) {
    return
  }

  const modal = new ShareModal(modalEl)

  document.querySelectorAll('.product__share-button').forEach((el) => {
    el.addEventListener('click', () => {
      modal.open()
    })
  })
}
